module.exports = __webpack_public_path__ + "media/images/ui__textArrowDown--dark-124a210e632f91f333dae92c1ee79e92.png";